import { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { authReady } from '../services/auth/tokenCache'; // ajuste o path se necessário

const API_BASE_URL = process.env.REACT_APP_API_SUPORTE_URL;

function parseData(str) {
  if (!str || !str.includes(' ')) return new Date(0);
  const [dataStr, horaStr] = str.split(' ');
  const [dia, mes, ano] = dataStr.split('/').map(Number);
  const [horas, minutos] = horaStr.split(':').map(Number);
  return new Date(ano, mes - 1, dia, horas || 0, minutos || 0);
}

function getLimiteData(periodo) {
  const agora = new Date();
  if (periodo === 'dia') {
    return new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());
  }
  if (periodo === 'semana') {
    const limite = new Date(agora);
    limite.setDate(agora.getDate() - 7);
    return limite;
  }
  if (periodo === 'mes') {
    const limite = new Date(agora);
    limite.setDate(agora.getDate() - 30);
    return limite;
  }
  return new Date(0);
}

export function useAccessHistory(userId) {
  const [sessoesUnicas, setSessoesUnicas] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(true);
  const [filtroPeriodo, setFiltroPeriodo] = useState('semana');

  useEffect(() => {
    let isMounted = true;

    const fetchAcessos = async () => {
      if (!userId) {
        setIsLoadingHistory(false);
        return;
      }

      setIsLoadingHistory(true);
      try {
        await authReady();
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) throw new Error('Missing token');

        let idToken = await user.getIdToken();
        if (!idToken) throw new Error('Missing token');

        const url = `${API_BASE_URL}/historico/acessos/${encodeURIComponent(
          userId
        )}`;

        let res = await fetch(url, {
          headers: { Authorization: `Bearer ${idToken}` },
        });

        if (res.status === 401) {
          idToken = await user.getIdToken(true);
          res = await fetch(url, {
            headers: { Authorization: `Bearer ${idToken}` },
          });
        }

        if (!res.ok) throw new Error('Erro ao buscar histórico');

        const { sessoes = [] } = await res.json();
        const limite = getLimiteData(filtroPeriodo);

        const sessoesFiltradas = sessoes.filter((sessao) => {
          const inicio = parseData(sessao.inicio);
          return inicio >= limite;
        });

        const sessoesUnicasFiltradas = sessoesFiltradas.filter(
          (sessao, index, self) =>
            index ===
            self.findIndex(
              (s) =>
                s.inicio === sessao.inicio &&
                s.fim === sessao.fim &&
                s.duracao === sessao.duracao
            )
        );

        if (isMounted) setSessoesUnicas(sessoesUnicasFiltradas);
      } catch (error) {
        console.error('Erro ao carregar acessos:', error);
        if (isMounted) setSessoesUnicas([]);
      } finally {
        if (isMounted) setIsLoadingHistory(false);
      }
    };

    fetchAcessos();
    return () => {
      isMounted = false;
    };
  }, [userId, filtroPeriodo]);

  return { sessoesUnicas, isLoadingHistory, filtroPeriodo, setFiltroPeriodo };
}
